import { type UiFramework } from '../../../types'
import { RecurrenceCalendar } from '../../RecurrenceCalendar'
import { RecurrenceCalendarWrapper } from '../../RecurrenceCalendarWrapper'
import { RecurrenceEnd } from '../../RecurrenceEnd'
import { RecurrenceSettingsRoot } from '../../RecurrenceSettingsRoot'
import { RecurrenceSettingsSecondary } from '../../RecurrenceSettingsSecondary'
import { RecurrenceTypeDropdown } from '../../RecurrenceTypeDropdown'

type Props = {
  uiFramework: UiFramework
  inEditMode: boolean
}

export function RecurrenceSettingsDaily(props: Props) {
  const { uiFramework, inEditMode } = props
  return (
    <RecurrenceSettingsRoot>
      <RecurrenceCalendarWrapper>
        <RecurrenceTypeDropdown />
        <RecurrenceCalendar inEditMode={inEditMode} />
      </RecurrenceCalendarWrapper>
      <RecurrenceSettingsSecondary uiFramework={uiFramework}>
        <RecurrenceEnd />
      </RecurrenceSettingsSecondary>
    </RecurrenceSettingsRoot>
  )
}
